import { HeroFeaturedBanner } from '@ahc-digital/component-library';
import { Field, ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { CreateHeroFeaturedBannerModel } from './B03HeroFeaturedBanner.service';
import { PromptForUnavailableInTheme } from 'src/shared/PromptForUnavailableInTheme';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type B03HeroFeaturedBannerProps = RenderingProps<
  B03HeroFeaturedBannerFields,
  B03HeroFeaturedBannerRenderingParams
>;

export type B03HeroFeaturedBannerFields = {
  TaglineTop?: Field<string>;
  Headline?: Field<string>;
  TaglineBottom?: Field<string>;
  BackgroundImage?: ImageField;
  FirstCTA?: LinkField;
  FirstCTAIcon?: KeyValuePair;
  SecondCTA?: LinkField;
  SecondCTAIcon?: KeyValuePair;
  MobileBackgroundImage?: ImageField;
};

export type B03HeroFeaturedBannerRenderingParams = {
  Gradient?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export const Default = (props?: B03HeroFeaturedBannerProps) => {
  const context = useCustomSitecoreContext();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  if (context?.siteTheme?.value === 'Consumer')
    return (
      <PromptForUnavailableInTheme
        siteTheme={context?.siteTheme?.value}
        componentName={props?.rendering?.componentName}
      />
    );
  return (
    <HeroFeaturedBanner
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateHeroFeaturedBannerModel(props)}
    />
  );
};
